var React = require('react');

function BackendDropdownMenuDeliveryPolicies (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#000000","d":"M12.5 16c-0.276 0-0.5-0.224-0.5-0.5v-0.5c0-3.074 0.921-4.141 1.734-5.083 0.679-0.787 1.266-1.466 1.266-3.417 0-3.033-2.692-5.5-6-5.5s-6 2.467-6 5.5v0.5c0 0.046-0.006 0.093-0.019 0.137l-0.818 2.863h1.337c0.276 0 0.5 0.224 0.5 0.5v2c0 0.224 0.276 0.5 0.5 0.5h2c0.276 0 0.5 0.224 0.5 0.5v2c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1.5h-1.5c-0.771 0-1.5-0.729-1.5-1.5v-1.5h-1.5c-0.157 0-0.305-0.074-0.399-0.199s-0.125-0.288-0.082-0.438l0.981-3.433v-0.43c0-1.744 0.733-3.381 2.065-4.61 1.32-1.219 3.073-1.89 4.935-1.89s3.615 0.671 4.935 1.89c1.331 1.229 2.065 2.866 2.065 4.61 0 2.323-0.767 3.212-1.509 4.071-0.767 0.888-1.491 1.727-1.491 4.429v0.5c0 0.276-0.224 0.5-0.5 0.5z","key":0}),React.createElement("path",{"fill":"#ccc","d":"M9 2.5c-2.209 0-4 1.231-4 2.75v0.25c0 1.381 1.119 2.5 2.5 2.5h1.768c0.346 0.598 0.992 1 1.732 1 1.105 0 2-0.895 2-2v-1.75c0-1.519-1.791-2.75-4-2.75z","key":1})]);
}

BackendDropdownMenuDeliveryPolicies.displayName = "BackendDropdownMenuDeliveryPolicies";

BackendDropdownMenuDeliveryPolicies.defaultProps = {"version":"1.1","width":"100%","height":"100%","viewBox":"0 0 16 16"};

module.exports = BackendDropdownMenuDeliveryPolicies;

BackendDropdownMenuDeliveryPolicies.default = BackendDropdownMenuDeliveryPolicies;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/svg/menu-icons/backend-dropdown-menu-delivery-policies.svg
// module id = 998
// module chunks = 0